module.exports = __webpack_public_path__ + "static/media/code_invitation.45ad796a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code_invitation.png
// module id = 164
// module chunks = 0